"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateTimeFilter = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Grid_1 = require("../../../components/Grid");
var MDIcon_1 = require("../../../components/MDIcon");
var Popover_1 = require("../../../components/Popover");
var react_1 = require("react");
var R = __importStar(require("../../../utils/ramda"));
var Row_1 = require("../../../components/Row");
var datefns = __importStar(require("date-fns"));
var DateTimeFilter = function (valueParser, buttons) {
  if (buttons === void 0) {
    buttons = [];
  }
  return (0, react_1.forwardRef)(function (props, ref) {
    var _a = __read((0, react_1.useState)(null), 2),
      startDate = _a[0],
      setStartDate = _a[1];
    var _b = __read((0, react_1.useState)(null), 2),
      endDate = _b[0],
      setEndDate = _b[1];
    var _c = __read((0, react_1.useState)(null), 2),
      appliedStartDate = _c[0],
      setAppliedStartDate = _c[1];
    var _d = __read((0, react_1.useState)(null), 2),
      appliedEndDate = _d[0],
      setAppliedEndDate = _d[1];
    var _e = __read((0, react_1.useState)(""), 2),
      appliedStartDateTextValue = _e[0],
      setStartDateTextValue = _e[1];
    var _f = __read((0, react_1.useState)(""), 2),
      appliedEndDateTextValue = _f[0],
      setEndDateTextValue = _f[1];
    (0, react_1.useImperativeHandle)(ref, function () {
      return {
        doesFilterPass: function (params) {
          var v = valueParser(params);
          if (R.isNil(v)) return false;
          if (appliedStartDate !== null && datefns.isBefore(v, appliedStartDate)) return false;
          if (appliedEndDate !== null && datefns.isAfter(v, appliedEndDate)) return false;
          return true;
        },
        isFilterActive: function () {
          return startDate !== null || endDate !== null;
        },
        getModel: function () {},
        setModel: function () {}
      };
    });
    (0, react_1.useEffect)(function () {
      props.filterChangedCallback();
    }, [appliedStartDate, appliedEndDate]);
    var startInputRef = (0, react_1.useRef)(null);
    var clearStartInput = function () {
      setStartDate(null);
      if (startInputRef.current) {
        startInputRef.current.value = "";
      }
    };
    var endInputRef = (0, react_1.useRef)(null);
    var clearEndInput = function () {
      setEndDate(null);
      if (endInputRef.current) {
        endInputRef.current.value = "";
      }
    };
    var onApply = function () {
      var _a, _b, _c, _d;
      setAppliedStartDate(startDate);
      setAppliedEndDate(endDate);
      setStartDateTextValue((_b = (_a = startInputRef.current) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : "");
      setEndDateTextValue((_d = (_c = endInputRef.current) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : "");
    };
    var onClear = function () {
      setStartDate(null);
      setEndDate(null);
      if (startInputRef.current) {
        startInputRef.current.value = "";
      }
      if (endInputRef.current) {
        endInputRef.current.value = "";
      }
    };
    var onReset = function () {
      onClear();
      setAppliedStartDate(null);
      setAppliedEndDate(null);
    };
    var onCancel = function () {
      setStartDate(appliedStartDate);
      setEndDate(appliedEndDate);
      if (startInputRef.current) {
        startInputRef.current.value = appliedStartDateTextValue;
      }
      if (endInputRef.current) {
        endInputRef.current.value = appliedEndDateTextValue;
      }
    };
    // if there's no apply button, apply automatically on change
    (0, react_1.useEffect)(function () {
      if (!buttons.includes("apply")) {
        onApply();
      }
    }, [startDate, endDate]);
    var buttonMap = {
      apply: (0, jsx_runtime_1.jsx)("button", __assign({
        onClick: onApply,
        className: "ag-standard-button ag-filter-apply-panel-button filter-button"
      }, {
        children: "Apply"
      }), "apply"),
      cancel: (0, jsx_runtime_1.jsx)("button", __assign({
        onClick: onCancel,
        className: "ag-standard-button ag-filter-cancel-panel-button filter-button"
      }, {
        children: "Cancel"
      }), "cancel"),
      clear: (0, jsx_runtime_1.jsx)("button", __assign({
        onClick: onClear,
        className: "ag-standard-button ag-filter-clear-panel-button filter-button"
      }, {
        children: "Clear"
      }), "clear"),
      reset: (0, jsx_runtime_1.jsx)("button", __assign({
        onClick: onReset,
        className: "ag-standard-button ag-filter-reset-panel-button filter-button"
      }, {
        children: "Reset"
      }), "reset")
    };
    return (0, jsx_runtime_1.jsxs)(Grid_1.Grid, __assign({
      className: "vsx-data-grid-datetime-filter",
      justify: "end",
      align: "center",
      padding: "medium",
      gap: "medium",
      columns: "auto 1fr auto"
    }, {
      children: [(0, jsx_runtime_1.jsxs)("div", __assign({
        style: {
          display: "contents"
        }
      }, {
        children: [(0, jsx_runtime_1.jsx)("span", __assign({
          className: "vsx-datetimefilter-label"
        }, {
          children: "Start"
        })), (0, jsx_runtime_1.jsx)(DateFilterInput, {
          refObject: startInputRef,
          onChange: setStartDate
        }), (0, jsx_runtime_1.jsx)(Popover_1.HoverPopover, __assign({
          interactive: false,
          tooltip: true,
          content: "CLEAR"
        }, {
          children: (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
            size: "1.3em",
            className: "vsx-datetimefilter-close-btn",
            icon: "close",
            onClick: clearStartInput
          })
        }))]
      })), (0, jsx_runtime_1.jsxs)("div", __assign({
        style: {
          display: "contents"
        }
      }, {
        children: [(0, jsx_runtime_1.jsx)("span", __assign({
          className: "vsx-datetimefilter-label"
        }, {
          children: "End"
        })), (0, jsx_runtime_1.jsx)(DateFilterInput, {
          refObject: endInputRef,
          onChange: setEndDate
        }), (0, jsx_runtime_1.jsx)(Popover_1.HoverPopover, __assign({
          interactive: false,
          tooltip: true,
          content: "CLEAR"
        }, {
          children: (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
            size: "1.3em",
            className: "vsx-datetimefilter-close-btn",
            icon: "close",
            onClick: clearEndInput
          })
        }))]
      })), (0, jsx_runtime_1.jsx)("span", {}), (0, jsx_runtime_1.jsx)(Row_1.Row, __assign({
        gap: "small",
        justify: "end"
      }, {
        children: R.uniq(buttons).map(function (b) {
          return buttonMap[b];
        })
      })), (0, jsx_runtime_1.jsx)("span", {})]
    }));
  });
};
exports.DateTimeFilter = DateTimeFilter;
var DateFilterInput = function (props) {
  return (0, jsx_runtime_1.jsx)("input", {
    style: {
      minWidth: "200px",
      fontFamily: "unset"
    },
    ref: props.refObject,
    type: "datetime-local",
    onChange: function (e) {
      if (e.currentTarget.valueAsNumber) {
        var date = datefns.toDate(e.currentTarget.valueAsNumber);
        var adjustedDate = datefns.addMinutes(date, date.getTimezoneOffset());
        props.onChange(adjustedDate);
      } else {
        props.onChange(null);
      }
    }
  });
};